<template>
<div class="publishers-list">
  <b-row style="margin-bottom: 1.5rem">
    <b-col>
      <label :for="$t('views.publishers.list.filters.name')" class="sr-only" style="position: relative; top: .2rem;">{{ $t('views.publishers.list.filters.name') }}</label>
      <pcg-text-input
          class="no-margin my-input"
          :id="$t('views.publishers.list.filters.name')"
          :show-label="false"
          :placeholder="$t('views.publishers.list.filters.name')"
          v-model="filters.name"
          @input="getFilteredPublishers"
      />
    </b-col>
  </b-row>
  <b-row>
    <b-col cols="10">
      <span class="per_page">{{ $t('views.achievement.list.per_page') }}</span>
      <pcg-select
          class="my-select-short"
          style="display: inline-block"
          :options="perPageOptions"
          :default-option="{ text: perPage.toString(), value: perPage }"
          v-model="perPage"
          @input="getFilteredPublishers"
      />
    </b-col>
    <b-col class="text-right">
      <pcg-btn v-if="(hasRight('edit_dictionaries') && tabModel === 0) || (hasRight('edit_own_dictionaries') && tabModel === 1)" variant="additional" size="small" @click="publisherAdd">
        {{$t('general.add')}}
      </pcg-btn>
    </b-col>
  </b-row>
  <b-tabs class="mt-3" v-model="tabModel">
    <b-tab :title="$t('views.publishers.list.ministerial_list')">
      <b-table v-if="publishers.length > 0"
               class="publishers-table"
               borderless hover
               thead-class="sthead"
               tbody-tr-class="strow"
               :fields="fields"
               :items="publishers"
               :primary-key="publishers.id"
      >
        <template v-slot:cell(name)="data">
          {{ data.value }}
        </template>
        <template v-for="(pubPoints, index) in publishers[0].publisherPoints" v-slot:[`cell(points${pubPoints.period})`]="data">
          {{ data.item.publisherPoints[index].points}}
        </template>
        <template v-slot:cell(id)="data">
          <span v-if="hasRight('edit_dictionaries') && !data.item.removed" class="clicked small ml-1 publisher-edit" @click="publisherEdit(data.value)">
            <i class="fas fa-pen small"></i>
            {{ $t('general.edit') }}
          </span>
          <span v-if="data.item.removed" class="small ml-1 item-deleted">
            {{ $t('general.deleted') }}
          </span>
        </template>
      </b-table>
      <nav :aria-label="$t('general.pagination')">
        <pcg-pagination
            v-model="pagination.page"
            :page-count="pagination.pages"
            :total-records="pagination.count"
            @input="getPublishers"
            class="col-12 justify-content-center my-pagination"
            style="margin-top: 2rem"
            :only-event="true"
        ></pcg-pagination>
      </nav>
    </b-tab>
    <b-tab :title="$t('views.publishers.list.other_list')" v-if="academyId !== 'undefined' && academyId !== undefined">
      <b-table v-if="locals.length > 0"
               class="publishers-table"
               borderless hover
               thead-class="sthead"
               tbody-tr-class="strow"
               :fields="otherFields"
               :items="locals"
               :primary-key="locals.id"
      >
        <template v-slot:cell(name)="data">
          {{ data.value }}
        </template>
        <template v-slot:cell(id)="data">
          <a href="javascript:;" :aria-label="$t('general.edit')" class="my-pen button-element" style="display: inline-block" v-if="hasRight('edit_own_dictionaries')" @click="publisherEdit(data.value)">
            <i class="fas fa-pen academy-icon" :id="`edit-publisher-` + data.value"></i>
            <b-tooltip :target="`edit-publisher-` + data.value">
              {{ $t('general.edit') }}
            </b-tooltip>
          </a>
          <a href="javascript:;" :aria-label="$t('general.delete')" class="text-danger button-element" style="display: inline-block" v-if="hasRight('edit_own_dictionaries')" @click="publisherRemove(data.value)">
            <i class="fas fa-trash academy-icon" :id="`delete-publisher-` + data.value"></i>
            <b-tooltip :target="`delete-publisher-` + data.value">
              {{ $t('general.delete') }}
            </b-tooltip>
          </a>
        </template>
      </b-table>
      <nav :aria-label="$t('general.pagination')">
        <pcg-pagination
            v-model="localPagination.page"
            :page-count="localPagination.pages"
            :total-records="localPagination.count"
            @input="getPublishers"
            class="col-12 justify-content-center my-pagination"
            style="margin-top: 2rem"
            :only-event="true"
        ></pcg-pagination>
      </nav>
    </b-tab>
  </b-tabs>
  <b-modal ref="publisherModal"
           :hide-header="true"
           :centered="true"
           v-bind:ok-title="$t('general.confirm')"
           ok-variant="primary"
           :no-close-on-esc="true"
           @ok="publisherSave"
           @hide="publisherEsc"
           v-bind:cancel-title="$t('general.cancel')"
           cancel-variant="default"
           v-on-clickaway = "publisherEsc"
           footer-class="my-modal-footer"
           content-class="my-modal-content"
  >
    <div class="edit-discipline" style="display: inline-block">{{ $t('views.publishers.list.modal.title') }}</div>
    <pcg-text-input
        class="my-field"
        :label="$t('views.publishers.list.modal.name')"
        v-model="mPublisher.name"
    />
    <div v-if="!mPublisher.academyId">
      <pcg-input-number
          v-for="(publisherPoint, index) in mPublisher.publisherPoints"
          :key="publisherPoint.id"
          class="my-field"
          style="margin-bottom: 1.5rem"
          :label="`${$t('views.publishers.list.modal.points')} ${mPublisher.publisherPoints[index].period}`"
          v-model="mPublisher.publisherPoints[index].points"
      />
    </div>
  </b-modal>
  <b-modal ref="localPublisherModal"
           :hide-header="true"
           :centered="true"
           v-bind:ok-title="$t('general.confirm')"
           ok-variant="primary"
           :no-close-on-esc="true"
           @ok="publisherSave"
           @hide="publisherEsc"
           v-bind:cancel-title="$t('general.cancel')"
           cancel-variant="default"
           v-on-clickaway = "publisherEsc"
           footer-class="my-modal-footer"
           content-class="my-modal-content"
  >
    <div class="edit-discipline" style="display: inline-block">{{ $t('views.publishers.list.modal.title') }}</div>
    <pcg-text-input
      class="my-field"
      :label="$t('views.publishers.list.modal.name')"
      v-model="mPublisher.name"
    />
  </b-modal>
  <b-modal ref="clearModal"
           :hide-header="true"
           footer-class="my-modal-footer"
           :centered="true"
           v-bind:ok-title="$t('general.confirm')"
           ok-variant="primary"
           :no-close-on-esc="true"
           @ok="publisherDestroy"
           v-bind:cancel-title="$t('general.cancel')"
           cancel-variant="default"
           content-class="my-modal-content"
  >
    <div class="confirm-header">{{ $t('views.publishers.list.modal.cleaning_title') }}</div>
    <div class="confirm-text">
      <span>{{ $t('views.publishers.list.modal.publications') }}: {{ this.publications }}</span>
    </div>
    <div class="confirm-text">
      <span>{{ $t('views.publishers.list.modal.duplicates') }}: {{ this.duplicates }}</span>
    </div>
    <div class="confirm-text">{{ $t('views.publishers.list.modal.cleaning_confirmation') }}</div>
  </b-modal>
  <b-modal ref="alternativeClearModal"
           :hide-header="true"
           footer-class="my-modal-footer"
           :centered="true"
           v-bind:ok-title="$t('general.confirm')"
           ok-variant="primary"
           :no-close-on-esc="true"
           @ok="publisherHide"
           v-bind:cancel-title="$t('general.cancel')"
           cancel-variant="default"
           content-class="my-modal-content"
  >
    <div class="confirm-header">{{ $t('views.publishers.list.modal.cleaning_title') }}</div>
    <div class="confirm-text">
      <span>{{ $t('views.publishers.list.modal.publications') }}: {{ this.publications }}</span>
    </div>
    <div class="confirm-text">
      <span>{{ $t('views.publishers.list.modal.duplicates') }}: {{ this.duplicates }}</span>
    </div>
    <div class="confirm-text">{{ $t('views.publishers.list.modal.cannot_delete') }}</div>
  </b-modal>
</div>
</template>

<script>
import ApiPublishers from '../../api/publishers'
import { mixin as clickaway } from 'vue-clickaway'
import hasRight from '../../mixins/has_right'
import setTitle from '../../mixins/set_title'
import { mapGetters } from 'vuex'

export default {
  name: 'PublishersList',
  mixins: [hasRight, setTitle, clickaway],
  data: function () {
    return {
      headerTitle: 'views.publishers.list.title',
      headerSubtitle: 'views.publishers.list.subtitle',

      filters: {
        name: null
      },
      publishers: [],
      locals: [],
      mPublisher: {
        id: null,
        name: null,
        publisherPoints: []
      },
      pagination: {
        count: 0,
        items: 0,
        last: 0,
        next: null,
        page: 0,
        pages: 0,
        prev: null
      },
      localPagination: {
        count: 0,
        items: 0,
        last: 0,
        next: null,
        page: 0,
        pages: 0,
        prev: null
      },
      perPage: 25,
      tabModel: 0,
      forDestroy: null,
      publications: 0,
      duplicates: 0,
      acceptedPub: false
    }
  },
  computed: {
    ...mapGetters('auth', ['academyId']),
    fields: function () {
      return [
        {
          key: 'name',
          label: '',
          class: 'td-left',
          thStyle: ''
        }
      ]
    },
    otherFields: function () {
      return [
        {
          key: 'name',
          label: '',
          class: 'td-left',
          thStyle: ''
        },
        {
          key: 'id',
          label: '',
          thStyle: 'width: 8rem;'
        }
      ]
    },
    perPageOptions () {
      return [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ]
    }
  },
  mounted () {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    this.setTitles()
    ApiPublishers.getPublishers(this.$route.query)
      .then(result => {
        const query = this.$route.query
        if (Object.prototype.hasOwnProperty.call(query, 'name')) {
          this.filters.name = query.name
        }
        this.publishers = result.data.datas
        this.locals = result.data.locals
        this.pagination = result.data.pagination
        this.localPagination = result.data.localPagination
        this.perPage = this.pagination.items || 25
        this.publishers[0].publisherPoints.forEach(publisherPoint => {
          this.fields.push(
              {
                key: `points${publisherPoint.period}`,
                label: `${this.$t('views.publishers.list.modal.points')} ${publisherPoint.period}`,
                thStyle: 'width: 7rem;'
              }
          )
        })
        this.fields.push(
            {
              key: 'id',
              label: '',
              thStyle: 'width: 6rem;'
            }
        )
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    publisherAdd () {
      this.mPublisher = {
        id: null,
        name: null,
        publisherPoints: []
      }
      if (this.tabModel === 0) {
        this.mPublisher.academyId = null
        this.publishers[0].publisherPoints.forEach(publisherPoint => {
          this.mPublisher.publisherPoints.push(
              {
                period: publisherPoint.period,
                points: 0
              }
          )
        })
        this.$refs.publisherModal.show()
      } else {
        this.mPublisher.academyId = this.academyId
        this.$refs.localPublisherModal.show()
      }
    },
    publisherEdit (id) {
      let publisher = this.publishers.find(el => {
        return el.id === id
      })
      if (publisher === undefined) {
        publisher = this.locals.find(el => {
          return el.id === id
        })
      }
      Object.assign(this.mPublisher, publisher)
      if (this.tabModel === 0) {
        this.$refs.publisherModal.show()
      } else {
        this.$refs.localPublisherModal.show()
      }
    },
    publisherEsc () {
      this.mPublisher = {
        id: null,
        name: null,
        publisherPoints: []
      }
    },
    publisherSave (modalEvt) {
      modalEvt.preventDefault()
      if (this.mPublisher.id) {
        const p = {}
        Object.assign(p, this.mPublisher)
        const idx = this.publishers.findIndex(el => {
          return this.mPublisher.id === el.id
        })
        const lidx = this.locals.findIndex(el => {
          return this.mPublisher.id === el.id
        })
        ApiPublishers.updatePublisher(this.mPublisher)
          .then(result => {
            if (idx > -1) {
              Object.assign(this.publishers[idx], p)
            }
            if (lidx > -1) {
              Object.assign(this.locals[lidx], p)
            }
            this.$toastr.s('Success')
            if (this.tabModel === 0) {
              this.$refs.publisherModal.hide()
            } else {
              this.$refs.localPublisherModal.hide()
            }
            this.mPublisher = {
              id: null,
              name: null,
              publisherPoints: []
            }
          })
          .catch(err => {
            const datas = err.response.data
            const message = []
            for (const key in datas) {
              message.push(`${datas[key]}`)
            }
            this.$toastr.e(message.join('\n'))
            Object.assign(this.mPublisher, p)
          })
      } else {
        ApiPublishers.createPublisher(this.mPublisher)
          .then(result => {
            if (this.tabModel === 0) {
              this.$refs.publisherModal.hide()
            } else {
              this.$refs.localPublisherModal.hide()
            }
            this.mPublisher = {
              id: null,
              name: null,
              publisherPoints: []
            }
            this.$toastr.s('Success')
            setTimeout(() => {
              ApiPublishers.getPublishers(this.$route.query)
                .then(result => {
                  const query = this.$route.query
                  if (Object.prototype.hasOwnProperty.call(query, 'name')) {
                    this.filters.name = query.name
                  }
                  this.publishers = result.data.datas
                  this.locals = result.data.locals
                  this.pagination = result.data.pagination
                  this.localPagination = result.data.localPagination
                  this.perPage = this.pagination.items || 25
                })
                .catch(error => {
                  console.log(error)
                })
            }, 1000)
          })
          .catch(err => {
            const datas = err.response.data
            const message = []
            for (const key in datas) {
              message.push(`${datas[key]}`)
            }
            this.$toastr.e(message.join('\n'))
            // Object.assign(this.mPublisher, p)
          })
      }
    },
    publisherRemove (id) {
      this.forDestroy = this.locals.find(el => {
        return el.id === id
      })
      ApiPublishers.getPublications(id)
        .then(result => {
          this.publications = result.data.pubs
          this.duplicates = result.data.duplicates
          this.acceptedPub = result.data.acceptedPub
          if (this.acceptedPub) {
            this.$refs.alternativeClearModal.show()
          } else {
            this.$refs.clearModal.show()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    publisherDestroy () {
      ApiPublishers.deletePublisher(this.forDestroy.id)
        .then(result => {
          this.$refs.clearModal.hide()
          setTimeout(() => {
            ApiPublishers.getPublishers(this.$route.query)
              .then(result => {
                const query = this.$route.query
                if (Object.prototype.hasOwnProperty.call(query, 'name')) {
                  this.filters.name = query.name
                }
                this.publishers = result.data.datas
                this.locals = result.data.locals
                this.pagination = result.data.pagination
                this.localPagination = result.data.localPagination
                this.perPage = this.pagination.items || 25
              })
              .catch(error => {
                console.log(error)
              })
          }, 300)
        })
        .catch(error => {
          console.log(error)
        })
    },
    publisherHide () {
      this.$refs.alternativeClearModal.hide()
    },
    getPublishers () {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
      let query = {}
      query = Object.assign(query, this.filters)
      if (this.pagination.page !== 0) {
        query.page = this.pagination.page
      }
      if (this.localPagination.page !== 0) {
        query.local_page = this.localPagination.page
      }
      query.per_page = this.perPage
      this.$router.push({ name: 'publishers_list_path', query: query })
      ApiPublishers.getPublishers(query)
        .then(result => {
          const query = this.$route.query
          if (Object.prototype.hasOwnProperty.call(query, 'name')) {
            this.filters.name = query.name
          }
          this.publishers = result.data.datas
          this.locals = result.data.locals
          this.pagination = result.data.pagination
          this.localPagination = result.data.localPagination
        })
        .catch(error => {
          console.log(error)
        })
    },
    getFilteredPublishers () {
      this.pagination.page = 1
      this.localPagination.page = 1
      this.getPublishers()
    }

  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/stylesheets/vars';

  .publishers-table {
    margin-top: 1rem;
    background-color: $pcg-white;
  }

  /deep/ table.publishers-table {
    background-color: $pcg-white;
    border-radius: 15px;

    thead {
      background-color: $main-color;
      color: $pcg-white;

      th {
        padding-top: 15px;
        padding-bottom: 15px;
        padding-right: 0.5rem;
        padding-left: 0.5rem;
        vertical-align: middle;

        &.td-center {
          text-align: center;
        }
      }

      th:first-child {
        padding-left: 15px;
        border-top-left-radius: 15px;
      }

      th:last-child {
        padding-right: 15px;
        border-top-right-radius: 15px;
      }
    }

    tbody {
      padding-left: 15px;
      padding-right: 15px;
      background-color: $pcg-white;

      td {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-right: 0.5rem;
        padding-left: 0.5rem;
        vertical-align: top;
        color: $pcg-dark-gray;

        &.td-left {
          text-align: left;
          color: $main-color;
          font-weight: 400;
        }
      }

      td:first-child {
        padding-left: 15px;
      }

      td:last-child {
        padding-right: 15px;
      }

      tr {
        height: 42px;
      }

      tr:last-child {
        td {
          padding-bottom: 15px;
        }

        td:first-child {
          padding-left: 15px;
          border-bottom-left-radius: 15px;
        }

        td:last-child {
          padding-right: 15px;
          border-bottom-right-radius: 15px;
        }
      }
    }
  }

  .confirm-header {
    font-size: $font-size-m;
    font-weight: 400;
    color: $pcg-gray;
    margin-bottom: 1.5rem;
  }

  .confirm-text {
    font-weight: 400;
    color: $pcg-gray;
    margin-bottom: 1rem;
  }

  .edit-discipline {
    color: $pcg-gray;
    font-weight: 400;
    font-size: $font-size-l;
    margin-bottom: 1rem;
  }

  .my-field {
    margin-bottom: 1rem;
    position: relative;
    /deep/ .pcg-input-label {
      margin-bottom: 0.25rem;
      color: $pcg-gray;
    }
    /deep/ .pcg-input {
      height: calc(1.5em + 0.75rem + 2px);
    }
  }

  .publisher-edit {
    color: $main-active-color;
  }

  .my-select-short {
    margin-right: .8rem;
    margin-left: .7rem;
    position: relative;
    width: 100px;
    display: inline-block;
    ::v-deep .bootstrap-select .dropdown-toggle {
      height: calc(1.5em + 0.75em + 2px);
      color: $pcg-gray;
    }
    ::v-deep .filter-option-inner {
      position: relative;
      bottom: .45rem;
    }
  }

  .per_page {
    color: $pcg-gray;
    font-weight: 400;
    font-size: $font-size-s;
  }

  .button-element {
    cursor: pointer;
  }

  .my-pen {
    color: $main-active-color;
  }

  .academy-icon {
    padding: 12px;
    border-radius: 50%;
    background-color: #ecf9fd;
  }

  /deep/ .tooltip-inner {
    background: $pcg-white;
    color: $pcg-dark-gray;
    box-shadow: 0 3px 10px rgba(0, 0, 0, .2);
    font-weight: 400;
    padding: .5rem;
    border-color: $pcg-light-gray-background;
    border-style: solid;
    border-width: 1px;
    opacity: 1;
  }

  /deep/ .arrow::before {
    border-top-color: $pcg-light-gray-background !important;
  }

  .confirm-header {
    font-size: $font-size-m;
    font-weight: 400;
    color: $pcg-gray;
    margin-bottom: 1.5rem;
  }

  .confirm-text {
    font-weight: 400;
    color: $pcg-gray;
    margin-bottom: 1rem;
  }

  .item-deleted {
    color: $pcg-gray;
  }

</style>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/vars-contrast";
  .contrast {
    .edit-discipline {
      color: $pcg-gray;
    }
    .my-field {
      /deep/ .pcg-input-label {
        color: $pcg-gray;
      }
    }
    .publisher-edit {
      color: $main-active-color;
    }
    .my-pagination {
      /deep/ .page-item {
        &, &.disabled {
          .page-link {
            color: $pcg-the-darkest-gray !important;
            &:hover {
              color: $hover-color !important;
            }
          }
        }
        &.active {
          .page-link {
            background-color: $main-active-color !important;
            color: $pcg-white !important;
          }
        }
        &:first-child, &:last-child {
          .page-link {
            color: $main-active-color !important;
          }
        }
      }
    }
    .my-pen {
      color: $main-active-color;
    }
    .academy-icon {
      background-color: #ecf9fd;
    }
    /deep/ .tooltip-inner {
      background: $pcg-white;
      color: $pcg-dark-gray;
      box-shadow: 0 3px 10px rgba(0, 0, 0, .2);
      border-color: $pcg-light-gray;
    }
    /deep/ .arrow::before {
      border-top-color: $pcg-light-gray !important;
    }
    .confirm-header {
      color: $pcg-gray;
    }
    .confirm-text {
      color: $pcg-gray;
    }
    .item-deleted {
      color: $pcg-gray;
    }
  }
</style>

<style lang="scss">
  @import "../../assets/stylesheets/vars-contrast";
  .contrast {
    .publishers-table {
      background-color: $pcg-white !important;

      thead {
        background-color: $main-color !important;
        color: $pcg-white !important;
      }

      tbody {
        background-color: $pcg-white !important;

        td {
          color: $pcg-dark-gray !important;

          &.td-left {
            color: $main-color !important;
          }
        }
      }
    }
  }
</style>
